<script>
import router from 'router';
import each from 'lodash/each';
import get from 'lodash/get';
import VsAlert from 'viralstyle-ui/src/VsAlert';
import VsContainer from 'viralstyle-ui/src/VsContainer';
import { mapState } from 'vuex';

import campaignsEnum from '../_campaigns-enum';
import clientMixins from 'utils/client-mixins';
import { privileges } from 'domains/base/_base-enum';
import { infoValidator, productValidator } from '../_campaigns-validator';

export default {
  components: {
    VsContainer,
    VsAlert,
  },
  mixins: [clientMixins],
  props: {
    campaignId: String,
  },
  data: () => ({
    privileged: false,
    tabs: [
      campaignsEnum.INFO,
      campaignsEnum.UPSELLS,
      { value: campaignsEnum.CROSS_SELLS, text: 'Cross Sells' },
      campaignsEnum.PRODUCTS,
    ],
    activeTab: campaignsEnum.INFO,
  }),
  computed: mapState({
    processing: state => state.processing,
    currentUser: state => state.currentUser,
    currentCampaign: state => state.campaigns.currentCampaign,
  }),
  beforeRouteUpdate(to, from, next) {
    this.activeTab = to.name.replace('campaignsDetails', '').toLowerCase();
    next();
  },
  async created() {
    if (this.hasPrivilege(privileges.CAMPAIGN_DETAILS)) {
      this.privileged = true;

      this.activeTab = this.$route.name.replace('campaignsDetails', '').toLowerCase();
    } else {
      this.$router.replace('/');
    }
  },
  methods: {
    handleChangeTab(e) {
      this.$router.push({ name: `campaignsDetails${e.capitalize()}` });
    },
    async save() {
      switch (this.activeTab) {
        case campaignsEnum.UPSELLS:
          let upsell1 = this.currentCampaign.upsellData.upsells[0],
            upsell2 = this.currentCampaign.upsellData.upsells[1],
            upsell1Valid = (!upsell1 || !upsell1.validator.hasErrors()),
            upsell2Valid = (!upsell2 || !upsell2.validator.hasErrors());

          if (
            ((upsell1 && upsell1.dirty) || (upsell2 && upsell2.dirty)) &&
            upsell1Valid &&
            upsell2Valid
          ) {
            await this.$store.dispatch('updateCampaignUpsells');
          }

          this.$store.dispatch('updateCampaignInfo', { tab: campaignsEnum.INFO, campaignId: this.campaignId });
          break;
        case campaignsEnum.INFO:
          if (!infoValidator.hasErrors()) {
            this.$store.commit('resetStores');
            this.$store.dispatch('updateCampaignInfo', { tab: campaignsEnum.INFO, campaignId: this.campaignId });
          }
          break;
        case campaignsEnum.PRODUCTS:
          let hasErrors;

          for (let key in productValidator) {
            if (productValidator[key].hasErrors()) {
              hasErrors = true;
              break;
            }
          }

          if (!hasErrors) {
            try {
              let productsRes = await this.$store.dispatch('updateProducts'),
                defaultProductRes = await this.$store.dispatch('setDefaultProduct');

              await this.$store.dispatch('getProducts', productsRes.length ? productsRes[0] : defaultProductRes);
              each(this.currentCampaign.firstProductsWithColors, product => {
                this.$store.commit('updateState', { object: product, property: 'dirty', value: false });
              });
              each(productValidator, validator => validator.clear());
            } catch (e) {
              this.$store.dispatch('getProducts');
            }
          }

          break;
        case campaignsEnum.CROSS_SELLS:
          await this.$store.dispatch('updateCampaignInfo', { tab: campaignsEnum.INFO, campaignId: this.campaignId });
          break;
      }
    },
  },
};
</script>

<template lang='pug'>
.campaign-details(v-if='privileged && Object.keys(currentCampaign.info).length')
  .vs-container--settings-small
    vs-alert.vs-alert--campaign(
      v-if='campaignEnded',
      no-gutter,
      message='!--- Editing is Disabled ---!',
    )
    vs-container(
      hide-search,
      hide-date,
      title='Details',
      button-icon='content-save',
      button-text='save',
      :tabs='tabs',
      :active-tab='activeTab',
      :processing='processing',
      :button-not-visible='campaignEnded',
      :button-disabled='campaignEnded || processing',
      @container-button-click='save',
      @change-tab='handleChangeTab',
    )
      router-view(
        @save-campaign-details='save',
      )
</template>

<style>
@import '~import/index';
@import '~styles/index';

.campaign-details {
  margin: 0 10px;

  @include mq(mf-sm) {
    margin: 0 50px;
  }

  @include mq(mf-lg) {
    margin: 0 70px;
  }

  .vs-table__title-container {
    border-bottom: 1px solid $borderColor;
  }

  .form__full {
    margin-bottom: 0;
    margin-top: 2rem;

    &--mt-1 {
      margin-top: 1rem;
    }
  }
}
</style>
